export const TRIAL_SUBSCRIPTION = 'trial';
